import React from "react";
import { Link } from "react-router-dom";
import { business, stats } from "../data";
import {
  FaNewspaper,
  FaGlobe,
  FaUsers,
  FaBroadcastTower,
  FaCheckCircle,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
} from "react-icons/fa";

const About = () => {
  return (
    <section className="section pt-32 min-h-screen bg-gray-50">
      <div className="container mx-auto px-4">
        {/* Back Button */}
        <Link
          to="/"
          className="inline-flex items-center text-accent hover:text-opacity-80 transition mb-8 font-medium"
        >
          ← Back to Home
        </Link>

        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            About {business.name}
          </h1>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Your Window to Okara, Your Voice for Pakistan
          </p>
        </div>

        {/* Main Content */}
        <div className="max-w-5xl mx-auto bg-white p-8 rounded-xl shadow-lg">
          {/* Mission & Story */}
          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                <FaNewspaper className="text-accent" /> Our Story
              </h2>
              <p className="text-gray-600 leading-relaxed">
                <span className="font-semibold">{business.name}</span> was founded
                with a single mission: to deliver accurate, timely, and unbiased
                news to the people of Okara, Punjab, and beyond. What started as a
                local initiative has grown into a trusted source of information for
                thousands of readers and viewers.
              </p>
              <p className="text-gray-600 leading-relaxed mt-4">
                From breaking political developments to agricultural updates,
                sports coverage, and community stories – we are committed to
                journalistic integrity and public service.
              </p>
            </div>
            <div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                <FaGlobe className="text-accent" /> Our Mission
              </h2>
              <p className="text-gray-600 leading-relaxed">
                To empower citizens with reliable news and in-depth analysis,
                bridging the gap between local communities and national affairs.
                We believe in the power of information to drive positive change.
              </p>
              <div className="bg-gray-50 p-5 rounded-lg mt-6 space-y-2">
                <h3 className="font-semibold text-gray-800 mb-2 flex items-center gap-2">
                  <FaMapMarkerAlt className="text-accent" /> Contact & Location
                </h3>
                <p className="text-gray-600 text-sm">{business.address}</p>
                <p className="text-gray-600 text-sm flex items-center gap-2">
                  <FaPhone className="text-accent" /> {business.phone}
                </p>
                <p className="text-gray-600 text-sm flex items-center gap-2">
                  <FaEnvelope className="text-accent" /> {business.email}
                </p>
              </div>
            </div>
          </div>

          {/* Stats */}
          <div className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-800 mb-6 text-center">
              Our Impact in Numbers
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {stats.map((stat, index) => (
                <div
                  key={index}
                  className="bg-accent/5 p-6 rounded-lg text-center hover:shadow-md transition"
                >
                  <div className="text-3xl font-bold text-accent">{stat.value}</div>
                  <div className="text-sm text-gray-600 mt-1">{stat.text}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Values / Coverage Areas */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-800 mb-6 text-center">
              What We Cover
            </h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
              <div className="flex items-center gap-3 bg-gray-50 p-4 rounded-lg">
                <FaBroadcastTower className="text-red-500 text-xl" />
                <span className="font-medium">Breaking News</span>
              </div>
              <div className="flex items-center gap-3 bg-gray-50 p-4 rounded-lg">
                <FaCheckCircle className="text-green-500 text-xl" />
                <span className="font-medium">Politics & Government</span>
              </div>
              <div className="flex items-center gap-3 bg-gray-50 p-4 rounded-lg">
                <FaUsers className="text-blue-500 text-xl" />
                <span className="font-medium">Community & Local</span>
              </div>
              <div className="flex items-center gap-3 bg-gray-50 p-4 rounded-lg">
                <FaGlobe className="text-purple-500 text-xl" />
                <span className="font-medium">International Affairs</span>
              </div>
            </div>
          </div>

          {/* Team / Credibility note */}
          <div className="mt-10 bg-accent/10 p-6 rounded-lg text-center border border-accent/20">
            <p className="text-gray-700 italic">
              “{business.name} – delivering news you can trust, 24/7.”
            </p>
            <div className="mt-3 text-sm text-gray-500">
              🇵🇰 Proudly serving Okara, Punjab, Pakistan, and the world.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;